module.exports = __webpack_public_path__ + "img/logo_clpgq.fb243c70.png";